
import { Link } from 'react-router-dom';
import { WhatsAppButton } from '../../components/whatsapp/WhatsAppButton';

export default function Footer() {
  return (
    <footer className="bg-black text-white">
      <WhatsAppButton />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo e Descrição */}
          <div className="flex col-span-1 md:col-span-2">
            <img 
              src="/logo.png" 
              alt="GZ Parts Logo" 
              className="h-20 w-auto mb-4"
            />
            <div className='ml-5'>
              <p className="text-gray-300 mb-4 max-w-md">
                Peças e acessórios para carros e motos nacionais, importados e clássicos.
              </p>
              <div className="flex space-x-4">
                <a href="https://www.facebook.com/profile.php?id=61573177282441" target="_blank" className="text-gray-400 hover:text-teal-400 cursor-pointer">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="https://www.instagram.com/_gzparts" target="_blank" className="text-gray-400 hover:text-teal-400 cursor-pointer">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                {/* <a href="#" target="_blank" className="text-gray-400 hover:text-teal-400 cursor-pointer">
                  <i className="ri-youtube-line text-xl"></i>
                </a> */}
                <a href="https://api.whatsapp.com/send/?phone=5511991542774" target="_blank" className="text-gray-400 hover:text-teal-400 cursor-pointer">
                  <i className="ri-whatsapp-line text-xl"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Links Rápidos */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Links Rápidos</h3>
            <ul className="space-y-2">
              <li><Link to="/catalogo" className="text-gray-300 hover:text-teal-400 cursor-pointer">Catálogo</Link></li>
              {/* <li><Link to="/modelos" className="text-gray-300 hover:text-teal-400 cursor-pointer">Por Modelo</Link></li> */}
              <li><Link to="/importacao" className="text-gray-300 hover:text-teal-400 cursor-pointer">Importação</Link></li>
              <li><Link to="/suporte" className="text-gray-300 hover:text-teal-400 cursor-pointer">Suporte Técnico</Link></li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contato</h3>
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                (11) 99154-2774
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                comercial@globalzeit.com.br
              </li>
              <li className="flex items-center">
                <i className="ri-time-line mr-2"></i>
                Seg-Sex: 8h às 18h
              </li>
              <li className="flex items-center">
                <i className="ri-global-line mr-2"></i>
                Loja 100% Online
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} GZ Parts. Todos os direitos reservados.
          </p>
          <div className="mt-4 md:mt-0 mr-6">
            <a 
              href="https://dialogotech.com.br" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-black text-sm transition-colors"
            >
              Desenvolvido por <img 
                src="/dialogo-logo.png" 
                alt="dIAlogo Tech Logo" 
                className="inline h-4 mr-2 ml-1"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
